import { FC, useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { COMMAND_PRIORITY_EDITOR, createCommand, LexicalCommand } from 'lexical';
import { $createInsertVideoNode, InsertVideoNode } from '../nodes/InsertVideoNode';
import { $insertNodeToNearestRoot } from '@lexical/utils';

export const INSERT_VIDEO_COMMAND: LexicalCommand<string> = createCommand();

export const InsertVideoPlugin: FC = () => {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        if (!editor.hasNodes([InsertVideoNode])) {
            throw new Error('InsertVideoPlugin: InsertVideoNode not registered on editor');
        }

        editor.registerCommand(
            INSERT_VIDEO_COMMAND,
            (payload: string) => {
                const insertVideoNode = $createInsertVideoNode(payload);
                $insertNodeToNearestRoot(insertVideoNode);

                return true;
            },
            COMMAND_PRIORITY_EDITOR
        )
    }, [editor]);

    return null;
};

export default InsertVideoPlugin;